import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../../../hooks/usePermission";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  notification,
  Table,
  Tooltip,
  Switch,
  Card,
  Modal,
  Input,
  Form,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import IMAGES from "../../../../const/Image";
import VideoRequest from "./VideoRequest";
import Search from "antd/es/input/Search";
import { components, getRowClassName } from "../../../../utils/utils";
const initialFilter = {
  page: 1,
};


const Video = () => {
  const hasListPermission = usePermission("Videos", "List");
  // console.log('Has list permission:', hasListPermission);
  const hasAddPermission = usePermission("Videos", "Add");
  const hasEditPermission = usePermission("Videos", "Edit");
  const hasDeletePermission = usePermission("Videos", "Delete");

  const [loading, setLoading] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const navigate = useNavigate();
  const { confirm } = Modal;
  const [form] = Form.useForm();
  const [contentType, setContentType] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fetchVideoList = () => {
    // const searchFilter = { ...filter, ...filterForm };
    setLoading(true);
    VideoRequest.videoList(filter)

      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        setVideoList(rawData);
        setFilteredVideos(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch videos.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchVideoList();
    if (hasListPermission) {
      fetchVideoList();
    }
  }, [filter, hasListPermission]);

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    setIsModalOpen(false);
  };

  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${
        checked ? "activate" : "deactivate"
      } this Video?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        VideoRequest.updatevideo({
          status: checked ? 1 : 0, // Make sure the status is either 1 or 0
          id: item.id,
          thumbnail: item.thumbnail,
          videoUrl: item.videoUrl,
        })
          .then((res) => {
            console.log("API response:", res);
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setVideoList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, is_active: checked ? 1 : 0 } : el
                )
              );
              fetchVideoList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      // width: 120,
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      // width: 200,
    },

    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",

      // width: 200,
      render: (dataIndex) => (
        <img
          src={dataIndex}
          alt="Modal Content"
          style={{ width: "100%", height: "66px", cursor: "pointer" }}
          onClick={() => showModal("image", dataIndex)}
        />
      ),
    },
    {
      title: "Video",
      dataIndex: "videoUrl",
      key: "videoUrl",
      // width: 220,
      render: (videoUrl) => {
        // Extract video ID from the YouTube watch URL
        const videoId = videoUrl.split("v=")[1]?.split("&")[0];
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;

        return (
          <iframe
            width="178"
            height="64"
            src={embedUrl} // Use the embed URL
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            title={videoUrl}
            onClick={() => showModal("video", embedUrl)}
            style={{ cursor: "pointer" }}
          />
        );
      },
    },
    {
      title: "Short Description",
      dataIndex: "shortDescription",
      key: "shortDescription",
      // width: 200,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      // width: 200,
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
      // width: 200,
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      key: "updatedBy",
      // width: 200,
    },
    {
      title: "Order By",
      dataIndex: "orderBy",
      key: "orderBy",
      // width: 200,
    },
    {
      title: "Status",
      dataIndex: "status",
      // width: 120,
      align: "center",
      render: (status, item) => (
        <Switch
          checked={status === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      // width: 120,
      render: (_, record) => (
        <Space size="middle">
            {hasEditPermission && (
          <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() =>
                navigate(`/app-setting/dashboard/video/${record.id}`)
              }
            >
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
            )}
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const showModal = (type, url) => {
    setContentType(type);
    setModalContent(url);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setContentType(null);
    setModalContent(null);
  };

  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Video</h1>
          </Col>

          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search by title"
                size="large"
                className="FilterSearchBox"
                onChange={(e) =>
                  setFilterForm({ ...filterForm, search: e.target.value })
                }
                value={filterForm?.search}
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleFilter();
                  }
                }}
              />

              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              <Button
                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>

              {hasAddPermission && (
              <Button
                onClick={() =>
                  navigate("/app-setting/dashboard/video/createVideo")
                }
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredVideos}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>

      {/* <Row gutter={[16, 16]}>
                {videoData.map((video, index) => (
                    <Col md={8} lg={8} key={index}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: 0 }}
                            cover={
                                <iframe
                                    title={video.title}
                                    src={video.url}
                                    frameBorder="0"
                                    allowFullScreen
                                    style={{ borderRadius: '10px' }}
                                    width="100%"
                                    height="200px"
                                    onClick={() => showModal("video", video.url)}
                                />
                            }
                        />
                    </Col>
                ))}
            </Row> */}

      <Modal
        title={contentType === "video" ? "Video" : "Image"}
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        width={contentType === "video" ? 800 : 600}
      >
        {contentType === "image" && (
          <img
            src={modalContent}
            alt="Modal Content"
            style={{ width: "100%" }}
          />
        )}
        {contentType === "video" && (
          <iframe
            width="100%"
            height="400px"
            src={modalContent} // Ensure the video URL is correct
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </Modal>
    </>
  );
};

export default Video;
